
import { Component, ModelSync, Prop, Vue } from 'nuxt-property-decorator'
import { NetworkType } from '~/components/sections/coverage/types'

@Component
export default class NetworkFilter extends Vue {
  @ModelSync('value', 'change', {
    required: true,
    type: String,
    default: '',
  })
  networkType!: NetworkType

  @Prop({ required: true, default: () => ([]), type: Array })
  readonly options!: Record<string, any>[]

  getOptionClassName (option: NetworkType) {
    const type = option.replace(/\+/g, 'plus')
    return `band--${type}`
  }
}
